import React from 'react';
import { useKaEmployee } from '../UserAccess/useKaEmployee';
import { Link } from 'react-router-dom';

export const OtherIntegrationsPage = () => {
  const employee = useKaEmployee();

  const ToEmployeeIntegrationUri = (uri: string) => {
    return uri.replace(/\.net/, '.net/kaEmployee');
  }

  const filteredIntegrations = employee.selectedBusiness!.integrations.filter(i => i.name !== 'FieldAlytics');

  return <>
    <h2 className='col-auto ka-blue mb-2'>Integrations</h2>
    {filteredIntegrations.map(i =>
      <div key={i.name} className="mt-5">
        <h3>
          <Link target="_blank" to={ToEmployeeIntegrationUri(`${i.configurationUri}?business_id=${employee.selectedBusiness!.id}`)}>
            {i.name}
            <i className="bi bi-box-arrow-up-right ms-1"></i>
          </Link>
        </h3>
      </div>
    )}
    {filteredIntegrations.length === 0 &&
      <h3>No integrations available</h3>
    }
    <h2 className='col-auto ka-blue mb-2 mt-5 pt-5'>External Integrations</h2>
    <div className="mt-5">
      <h3>
        <Link to="/employee/apiEventLog">
          API Event Log
          <i className="bi bi-box-arrow-up-right ms-1"></i>
        </Link>
      </h3>
    </div>
  </>
}


export default OtherIntegrationsPage;
